import { render } from "./FlightPoliciesView.vue?vue&type=template&id=ba7737e8"
import script from "./FlightPoliciesView.vue?vue&type=script&lang=js"
export * from "./FlightPoliciesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__